import React from 'react'
import { Route, Routes } from 'react-router'
import { BrowserRouter } from 'react-router-dom'
import ReactDOM from 'react-dom/client'
import reportWebVitals from '@/reportWebVitals'
import { ConfigProvider } from 'antd-mobile'
import HelmetProviders from '@/components/HelmetProviders'
import { getAntdLocale, setupI18n } from '@/components/i18n'
import { absorbSearch, applyResolvedPackageName } from '@/utils/packageIdentity'
import Invite from '@/pages/invite'
import National from '@/pages/national'
import LuckyGift from '@/pages/LuckyGift'
import RechargeSendVip from '@/pages/RechargeSendVip'
import RechargeSendMedal from '@/pages/RechargeSendMedal'
import NewYear from '@/pages/NewYear'
import CharmAnchor from '@/pages/CharmAnchor'
import RamadanAnswer from '@/pages/RamadanAnswer'
import RoomSupport from '@/pages/RoomSupport'
import RoomRewards from '@/pages/RoomRewards'
import RoomRewardsDay from '@/pages/RoomRewardsDay'
import GameRankings from './pages/Game/Rankings'
import FruitWheel from './pages/Game/FruitWheel'
import AgencyHonor from './pages/AgencyHonor'
import HostHonor from './pages/HostHonor'
import Raffle from './pages/Raffle'
import RoomCharm from './pages/RoomCharm'
import WeekStar from './pages/WeekStar'
import WeekCP from './pages/WeekCP'
import SupportStars from './pages/SupportStars'
import CheckIn from './pages/CheckIn'
import '@/index.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

async function bootstrap() {
  try {
    window.query = absorbSearch(window.location.search, localStorage)
  } catch (error) {
    console.error('absorbSearch failed:', error)
  }

  try {
    applyResolvedPackageName()
  } catch (error) {
    console.error('applyResolvedPackageName failed:', error)
  }

  try {
    await setupI18n()
  } catch (error) {
    console.error('setupI18n failed, fallback to English UI bootstrap:', error)
  }

  root.render(
    <ConfigProvider locale={getAntdLocale(window.lang || 'en')}>
      <HelmetProviders>
        <BrowserRouter>
          <Routes>
            <Route path="/">
              <Route path="invite" element={<Invite />} />
              <Route path="national" element={<National />} />
              <Route path="lucky-gift" element={<LuckyGift />} />
              <Route path="recharge-send-vip" element={<RechargeSendVip />} />
              <Route path="recharge-send-medal" element={<RechargeSendMedal />} />
              <Route path="new-year" element={<NewYear />} />
              <Route path="charm-anchor" element={<CharmAnchor />} />
              <Route path="ramadan-answer" element={<RamadanAnswer />} />
              <Route path="room-support" element={<RoomSupport />} />
              <Route path="room-rewards" element={<RoomRewards />} />
              <Route path="room-charm" element={<RoomCharm />} />
              <Route path="room-rewards-day" element={<RoomRewardsDay />} />
              <Route path="week-star" element={<WeekStar />} />
              <Route path="week-cp" element={<WeekCP />} />
              <Route path="agency-honor" element={<AgencyHonor />} />
              <Route path="king-of-mic" element={<HostHonor />} />
              <Route path="raffle" element={<Raffle />} />
              <Route path="support-stars" element={<SupportStars />} />
              <Route path="check-in" element={<CheckIn />} />
              <Route path="game">
                <Route path="rankings" element={<GameRankings />} />
                <Route path="fruit-wheel" element={<FruitWheel />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </HelmetProviders>
    </ConfigProvider>
  )

  reportWebVitals()
}

bootstrap()
